import { DateRangeIssue, ValidationSeverity, DateRangeIssueCode } from './dateRange.types';

const SEVERITY_PRIORITY: Record<ValidationSeverity, number> = {
  error: 0,
  warning: 1,
};

const ISSUE_PRIORITY: Record<DateRangeIssueCode, number> = {
  // Highest priority errors
  START_AND_END_REQUIRED: 0,

  START_AFTER_END: 1,

  START_REQUIRED: 2,
  END_REQUIRED: 2,

  START_BEFORE_HARD_MIN: 3,
  START_AFTER_HARD_MAX: 3,
  
  END_AFTER_HARD_MAX: 4,
  END_BEFORE_HARD_MIN: 4,

  DATE_RANGE_OVERLAP: 5,

  // Warnings (ordered after any error)
  START_BEFORE_SOFT_MIN: 10,
  END_AFTER_SOFT_MAX: 10,
};

export function compareDateRangeIssues(a: DateRangeIssue, b: DateRangeIssue) {
  const severityDiff =
    SEVERITY_PRIORITY[a.severity] - SEVERITY_PRIORITY[b.severity];

  if (severityDiff !== 0) {
    return severityDiff;
  }

  return ISSUE_PRIORITY[a.code] - ISSUE_PRIORITY[b.code];
}

export function splitAndOrderDateRangeIssues(issues: DateRangeIssue[]) {
  const ordered = [...issues].sort(compareDateRangeIssues);

  return {
    ordered,
    errors: ordered.filter(i => i.severity === 'error'),
    warnings: ordered.filter(i => i.severity === 'warning'),
    primary: ordered[0],
  };
}
